import { render, staticRenderFns } from "./program-tabs.vue?vue&type=template&id=2ff47b48"
import script from "./program-tabs.vue?vue&type=script&lang=js"
export * from "./program-tabs.vue?vue&type=script&lang=js"
import style0 from "./program-tabs.vue?vue&type=style&index=0&id=2ff47b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports